import React from 'react'
// @material-ui/core components
import '../../assets/css/ProductRanking/Dropdown.scss'

class Dropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sortBy: 'Sort By',
      category: 'Product Category',
      show: false,
    }
  }

    handleChange = (font, name, id) => () => {
      this.setState({ show: false })
      this.props.handleDropdownChange(font, name, id)
    }

    handleToggle = (e) => {
      e.target.focus()
      this.setState({ show: !this.state.show })
    }

    handleBlur = (e) => {
      // firefox onBlur issue workaround
      if (e.nativeEvent.explicitOriginalTarget &&
            e.nativeEvent.explicitOriginalTarget === e.nativeEvent.originalTarget) {
        return
      }

      if (this.state.show) {
        setTimeout(() => {
          this.setState({ show: false })
        }, 200)
      }
    }
    render() {
      const {
        options,
        name,
        value,
      } = this.props

      return (
        <div className="dropdown-container">
          <label className="arrow">
            <input
              type="button"
              value={value.val}
              className="dropdown-btn"
              onClick={this.handleToggle}
              onBlur={this.handleBlur}
            />
          </label>
          <ul className="dropdown-list" hidden={!this.state.show}>
            {options.map((font, index) => (
              <li
                key={index}
                className="option"
                onClick={this.handleChange(font.full_name, name, font._id)}
              >
                {font.full_name}
              </li>
            ))}
          </ul>
        </div>
      )
    }
}

export default Dropdown